import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { ConsumerReviewsEntities, DEFAULT_SORTING, SORT_BY } from 'client/data/models/consumer-reviews';
import { buildConsumerReviewsUrl } from 'site-modules/shared/utils/consumer-reviews/url-builder';
import { venomHistory } from 'client/utils/history/venom-history';
import { StyledSelect } from 'client/site-modules/shared/components/styled-select/styled-select';

export function SortDropdown({ reviewsFilter, vehicleFilter, addLoading = noop }) {
  const selectSort = useCallback(
    ({ value: sorting }) => {
      addLoading();

      setTimeout(() => {
        venomHistory.push(buildConsumerReviewsUrl({ ...reviewsFilter, sorting }, vehicleFilter));
      }, 0);
    },
    [reviewsFilter, vehicleFilter, addLoading]
  );

  return (
    <div className="sort-dropdown">
      <label id="sort-select-label" htmlFor="select-sort" className="heading-5">
        Sort by:
      </label>
      <StyledSelect
        value={reviewsFilter.sorting}
        options={SORT_BY}
        onChange={selectSort}
        name="select-sort"
        isFirstOptionDisabled={false}
        defaultValue={DEFAULT_SORTING}
        valueKey="value"
        labelKey="name"
        className="heading-5-inline ps-0_5 rounded"
        aria-labelledby="sort-select-label"
      />
    </div>
  );
}

SortDropdown.propTypes = {
  reviewsFilter: ConsumerReviewsEntities.ReviewsFilter.isRequired,
  vehicleFilter: ConsumerReviewsEntities.VehicleFilter.isRequired,
  addLoading: PropTypes.func,
};
